import * as React from 'react';

import { format } from 'helper/dateTime';
import { DISPLAY_FORMATS, PARSE_FORMATS } from 'helper/dateTime';
import i18n from 'helper/i18n';

import Icon from 'components/atoms/Icon';

export type MeasuringType = {
	weight: number;
	time?: string;
	date?: string;
};

export type MeasurementProps = {
	modifier?: string;
	unit?: string;
	title?: string;
	onEdit?: Function;
	measuring?: MeasuringType;
	showText?: boolean;
};

export default class Measurement extends React.Component<MeasurementProps> {
	public static defaultProps: MeasurementProps = {
		showText: true,
	};

	public handleEditClick = () => {
		if (typeof this.props.onEdit === 'function') {
			this.props.onEdit();
		}
	};

	public render() {
		const { modifier, showText, measuring, unit, title } = this.props;

		const titleLabel = title || i18n('react.impulsCoach.components.measurement.title');
		const text = i18n('react.impulsCoach.components.measurement.text');
		const unitLabel = unit || i18n('react.impulsCoach.components.measurement.unit');

		return (
			<div className={`m-measurement${modifier ? ` m-measurement--${modifier}` : ''}`}>
				{text && showText && <p className="m-measurement__text">{text}</p>}
				{<h6 className="m-measurement__title">{titleLabel}</h6>}
				{measuring && (
					<div className="m-measurement__box">
						{measuring.weight && (
							<div className="m-measurement__item">
								{measuring.weight} {unitLabel}
							</div>
						)}

						{measuring.date && <div className="m-measurement__item">{format(measuring.date)}</div>}
						{measuring.time && (
							<div className="m-measurement__item">
								{format(measuring.time, DISPLAY_FORMATS.TIME, PARSE_FORMATS.DATE_TIME)}
							</div>
						)}
						<span className="m-measurement__button" onClick={this.handleEditClick}>
							<Icon iconName={'pen'} />
						</span>
					</div>
				)}
			</div>
		);
	}
}
